import { needsDocusignSignIn } from '../../../../apollo/reactiveVariables/EsignProviderVariables';
import { Paths } from '../../../../common/enums/Paths';
import { ApprovalRequestType } from '../../../../data/types.generated';
import { LogCategory } from '../../../../logger';
import { AuthHelper } from '../../../../utilities/AuthHelper';
import { getAppHost } from '../../../../utilities/TeamsUtils';
import { clearCachedAuthToken, retrieveOAuthAccessToken, useInitializeNeedsSignInReactiveVar } from './utils';

export const docusignTokenCacheKey = 'docusign_oauth_token_v2';
export const docusignAuthStateKey = 'docusign.login.state';

export interface DocusignRequestDefaults {
    apiAccessPoint: string;
    token: string;
    userId: string;
}

export const useInitializeNeedsDocusignSignIn = (): boolean =>
    useInitializeNeedsSignInReactiveVar(ApprovalRequestType.Docusign, needsDocusignSignIn);

export const retrieveDocusignRequestDefaults = async (): Promise<DocusignRequestDefaults> => {
    const token = await retrieveOAuthAccessToken(ApprovalRequestType.Docusign);
    return {
        apiAccessPoint: token.apiBaseUrl,
        token: token.accessToken,
        userId: token.userId,
    };
};

export const docusignLogout = (): Promise<void> => {
    const logger = getAppHost().getLogger();
    logger.logTraceInfo(LogCategory.DocusignAuth, 'Calling docusignLogout');
    const docusignLogoutPath = window.location.origin + Paths.BasePath + Paths.DocusignLogoutStart;
    return AuthHelper.getAuthenticationFromTeams(docusignLogoutPath).then((): void => {
        clearCachedAuthToken(ApprovalRequestType.Docusign);
        needsDocusignSignIn(true);
    });
};
